import LoginBrick from './LoginBrick';
import { useDispatch, useSelector } from 'react-redux';
import FJAction from '../../action/FJAction';
import FJLocalStore from '../../store/FJLocalStore';

const LoginContainer = props => {
    const dispatch = useDispatch();
    let { popupType, stepChange } = props;
    const { email, passwordSeeLogin } = useSelector(store => {
        return {
            email: store.mainStore.email,
            passwordSeeLogin: store.mainStore.passwordSeeLogin,
        };
    });
    // 邮箱登录
    let _emailLogin = (password, callBack) => {
        dispatch(FJAction.emailLogin({ email: email, password: password }, callBack));
    };
    // 忘记密码点击
    let _forgetClick = () => {
        dispatch(FJAction.forgetPasswordAction({ email: email, code_language: FJLocalStore.currentTag() }));
    };
    let _changeLoginPasswordStatus = status => {
        dispatch(FJAction.changeLoginPasswordStatusAction(status));
    };
    return (
        <LoginBrick
            email={email}
            emailLogin={_emailLogin}
            stepChange={stepChange}
            forgetClick={_forgetClick}
            popupType={popupType}
            active={true}
            passwordSeeLogin={passwordSeeLogin}
            changePasswordSeeLogin={_changeLoginPasswordStatus}
        />
    );
};
export default LoginContainer;
